"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.predictedArtifact = void 0;
exports.predictedArtifact = {
    artifact_id: 99573834,
    type: "PREDICTION",
    identifier: "27855690",
    procedures: {
        automate: false,
        evidence: [],
        codes: [
            {
                procedure_id: 102977379,
                procedure_uid: null,
                evidence_source_uid: null,
                procedure_name: null,
                procedure_code: "70450",
                type: null,
                units: 1,
                sequence_number: 1,
                transaction_id: null,
                automate: false,
                confidence: 0.9939703307665028,
                evidence: [
                    {
                        type: "Categorical",
                        score: 0.15710039811564114,
                        feature: {
                            category: "Head and Neck",
                            field: "body_region",
                            type: "categorical"
                        }
                    },
                    {
                        type: "Categorical",
                        score: 0.0010854350154153591,
                        feature: {
                            category: "Computed Tomography",
                            field: "procedure_type",
                            type: "categorical"
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.00009582785044670583,
                        feature: {
                            slop: 2,
                            field: "exam_type",
                            in_order: true,
                            ngram: "head without",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.00006388420123293326,
                        feature: {
                            slop: 0,
                            field: "exam_type",
                            in_order: true,
                            ngram: "head without",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.00006388420123293326,
                        feature: {
                            slop: 1,
                            field: "exam_type",
                            in_order: true,
                            ngram: "head without",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.000033528355322332004,
                        feature: {
                            slop: 0,
                            field: "exam_type",
                            in_order: true,
                            ngram: "head",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.000033528355322332004,
                        feature: {
                            slop: 0,
                            field: "exam_type",
                            in_order: true,
                            ngram: "ct head",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.000033528355322332004,
                        feature: {
                            slop: 1,
                            field: "exam_type",
                            in_order: true,
                            ngram: "ct head",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.000033528355322332004,
                        feature: {
                            slop: 2,
                            field: "exam_type",
                            in_order: true,
                            ngram: "ct head",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.000033528355322332004,
                        feature: {
                            slop: 1,
                            field: "exam_type",
                            in_order: true,
                            ngram: "ct without",
                            type: "ngram",
                            spans: []
                        }
                    }
                ],
                modifier_codes: null,
                used: true,
                modifiers: {
                    confidence: 0,
                    automate: false,
                    evidence: [],
                    codes: []
                },
                diagnoses: {
                    confidence: 0,
                    primary_code_confidence: 0,
                    primary_predicted_code: null,
                    automate: false,
                    type: null,
                    evidence: [],
                    codes: []
                }
            }
        ],
        confidence: 0.9617768507375228
    },
    modifiers: {
        confidence: 0,
        automate: true,
        evidence: [],
        codes: []
    },
    diagnoses: {
        confidence: 0.0279362437879959,
        primary_code_confidence: 0.1139327385037749,
        primary_predicted_code: "R29.810",
        automate: false,
        type: null,
        evidence: [],
        codes: [
            {
                diagnosis_uid: null,
                diagnosis_code: "R29.810",
                evidence_source_uid: null,
                automate: false,
                confidence: 0.0654023318071738,
                sequence_number: 1,
                type: null,
                evidence: [
                    {
                        type: "Categorical",
                        score: 0.04200499051211121,
                        feature: {
                            category: "Head and Neck",
                            field: "body_region",
                            type: "categorical"
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.027785614899406993,
                        feature: {
                            slop: 0,
                            field: "raw_reasonforvisit",
                            in_order: true,
                            ngram: "stroke",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Categorical",
                        score: 0.01674041235952229,
                        feature: {
                            category: "1",
                            field: "date_of_birth",
                            type: "categorical"
                        }
                    },
                    {
                        type: "Categorical",
                        score: 0.01674041235952229,
                        feature: {
                            category: "2",
                            field: "date_of_service",
                            type: "categorical"
                        }
                    },
                    {
                        type: "Categorical",
                        score: 0.016733321841449614,
                        feature: {
                            category: "1",
                            field: "date_of_birth",
                            type: "categorical"
                        }
                    },
                    {
                        type: "Categorical",
                        score: 0.016733321841449614,
                        feature: {
                            category: "2",
                            field: "date_of_service",
                            type: "categorical"
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.014436340602482611,
                        feature: {
                            slop: 1,
                            field: "raw_body",
                            in_order: true,
                            ngram: "ganglia right",
                            type: "ngram",
                            spans: [
                                {
                                    start: 517,
                                    end: 538,
                                    level: "ngram",
                                    content: "al ganglia and the ri"
                                },
                                {
                                    start: 435,
                                    end: 597,
                                    level: "sentence",
                                    content: " Brain Parenchyma: Previously seen focal areas of hypoattenuation in the right basal ganglia and the right thalamus are not well appreciated on the current study."
                                },
                                {
                                    start: 1253,
                                    end: 1270,
                                    level: "ngram",
                                    content: "e right basal gan"
                                },
                                {
                                    start: 1187,
                                    end: 1335,
                                    level: "sentence",
                                    content: " Previously demonstrated small, punctate foci of hypodensity in the right basal ganglia and right thalamus are not appreciated on the current study."
                                }
                            ]
                        }
                    },
                    {
                        type: "Categorical",
                        score: 0.014307837151261701,
                        feature: {
                            category: "CT",
                            field: "procedure_category",
                            type: "categorical"
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.013634098971034507,
                        feature: {
                            slop: 1,
                            field: "exam_type",
                            in_order: true,
                            ngram: "head contrast",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.013600295462856016,
                        feature: {
                            slop: 2,
                            field: "exam_type",
                            in_order: true,
                            ngram: "head contrast",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.013482467468438557,
                        feature: {
                            slop: 2,
                            field: "exam_type",
                            in_order: true,
                            ngram: "ct without",
                            type: "ngram",
                            spans: []
                        }
                    },
                    {
                        type: "Ngram",
                        score: 0.012847953545101758,
                        feature: {
                            slop: 1,
                            field: "exam_type",
                            in_order: true,
                            ngram: "ct without",
                            type: "ngram",
                            spans: []
                        }
                    }
                ],
                used: true
            }
        ]
    }
};
//# sourceMappingURL=prediction.fixture.js.map